import React, { useEffect, useState } from 'react'
import { ButtonDep as Button } from '..'

type Props = {
  sitename: string
  onRenderLink?: () => JSX.Element
}

const CookieConsent = ({ sitename, onRenderLink }: Props) => {
  const onServer = typeof window === 'undefined'

  const [display, setDisplay] = useState(false)
  const COOKIE_TOKEN = 'ISLANDSSTOFA_COOKIE_CONSENT_' + sitename.toUpperCase()

  useEffect(() => {
    const getToken = () => (onServer ? '' : localStorage.getItem(COOKIE_TOKEN))
    !getToken() ? setDisplay(true) : setDisplay(false)
  }, [display, COOKIE_TOKEN, onServer])

  const setToken = () => (onServer ? '' : localStorage.setItem(COOKIE_TOKEN, 'true'))

  const toggle = () => {
    setToken()
    setDisplay(false)
  }

  if (display) {
    return (
      <div className='cookie-consent image-rounded--small container p-2 p-lg-0'>
        <div className='d-flex flex-column flex-lg-row align-items-center px-3 h-100'>
          <p className='mb-2 mb-lg-1 col-lg-9'>
            This website uses cookies to ensure you get the best experience on our website.
          </p>
          <div className='col-lg-3 cookie-consent__buttons'>
            <Button type='primary' label='Accept' onClick={() => toggle()} />
            {onRenderLink ? (
              onRenderLink()
            ) : (
              <a className='d-flex align-items-center ml-2' href='/privacy-policy'>
                <Button type='secondary' icon='arrowRight' label='Find out more' />
              </a>
            )}
          </div>
        </div>
      </div>
    )
  } else return null
}

export default CookieConsent
